import React, { useEffect, useState, useRef } from "react";
import './home.css';
import './header.css';
import './services.css';
import './about.css';
import './contact.css';
import './portfolio.css';
import './skills.css';
import './footer.css';
import './testimoial.css';
import '../../index.css'
import prof from '../../assests/prof.png';
import home from '../../assests/home.png';
import pros from '../../assests/pros.png'
import peter from '../../assests/Peters.png'
import First1 from '../../assests/about-omt.png';
import First2 from '../../assests/omt.png';
import First4 from '../../assests/4.png';
import First5 from '../../assests/5.png';
import First6 from '../../assests/6.png';
import Festal from '../../assests/Festal.png'
// import PortPic from '../../assests/portPic.png';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


import axios from 'axios';




const Home = () => {

    const [activeSection, setActiveSection] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [isSticky, setSticky] = useState(false);
    const [readMore, setReadMore] = useState(false);
    const [expandedService, setExpandedService] = useState(null)
    const swiperRef = useRef(true);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isModalsVisible, setIsModalsVisible] = useState(false);
    const [isModalCard, setIsModalCard] = useState(false);

    // axios.defaults.withCredentials = true;

    const [currentWordIndex, setCurrentWordIndex] = useState(0);
    const words = ["FullStack\u00A0JavaScript", "React.Js\u00A0Expert", "MERN\u00A0Stack", "UI/UX\u00A0Designer"];

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentWordIndex((prevIndex) => {
                return prevIndex === words.length - 1 ? 0 : prevIndex + 1;
            });
        }, 3000);
        return () => clearInterval(interval);
    }, []);

    ////////////////////////////Modal Visible Section\\\\\\\\\\\\\\\\\\\\\

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsModalVisible(true);
        }, 1000); // 1 seconds delay

        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        const timerr = setTimeout(() => {
            setIsModalsVisible(true);
        }, 1000); // 1 seconds delay

        return () => clearTimeout(timerr);
    }, []);

    useEffect(() => {
        const timers = setTimeout(() => {
            setIsModalCard(true);
        }, 1000); // 1 seconds delay

        return () => clearTimeout(timers);
    }, []);



    // ////////////////////////////////circle skill Javascript\\\\\\\\\\\\\\\\\\\\\\\\\\\

    const Circle = ({ dots, percent }) => {
        const [points, setPoints] = useState([]);

        useEffect(() => {
            try {
                let newPoints = [];
                let rotate = 360 / dots;
                let markedPercent = Math.floor((dots * percent) / 100);

                for (let i = 0; i < dots; i++) {
                    newPoints.push(
                        <div
                            key={i}
                            className={`points ${i < markedPercent ? 'marked' : ''}`}
                            style={{
                                transform: `rotate(${i < markedPercent ? `${rotate * i}deg` : '0deg'}) translateY(-45px)`,
                                '--i': i,
                                '--rot': rotate,
                            }}
                        />
                    );
                }

                setPoints(newPoints);
            } catch (error) {
                console.error('Error in Circle component:', error);
                // You can handle the error here (e.g., show a fallback UI)
            }
        }, [dots, percent]);

        return <div className="circle">{points}</div>;
    };

    // ////////////////////////////////mixitup.min.js Javascript\\\\\\\\\\\\\\\\\\\\\\\\\\\


    let mixer = null;

    useEffect(() => {
        if (window.mixitup) {
            if (!mixer) {
                mixer = window.mixitup('.portfolio-gallery');
            }
        }
    }, []);

    // ////////////////////////////////activeMenu Javascript\\\\\\\\\\\\\\\\\\\\\\\\\\\


    const sectionIds = ['home', 'about', 'services', 'skills', 'portfolio', 'testimonies', 'contact', 'footer'];

    const handleScroll = () => {
        const scrollPosition = window.scrollY + 97;
        const activeId = sectionIds.reduce((prevId, currId) => {
            const element = document.getElementById(currId);
            if (element.offsetTop <= scrollPosition) {
                return currId;
            } else {
                return prevId;
            }
        }, 'home');
        setActiveSection(activeId);
        localStorage.setItem('lastSection', activeId);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    // ////////////////////////////////sticky navbar\\\\\\\\\\\\\\\\\\\\\\\\\\\



    useEffect(() => {
        const stickyNav = () => {
            setSticky(window.scrollY > 50);
        };
        window.addEventListener('scroll', stickyNav);
        return () => {
            window.removeEventListener('scroll', stickyNav);
        };
    }, []);

    // -------------------------------------toggle open icon-------------------------------

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    }

    const closeMenu = () => {
        setIsOpen(false);
    }

    // ------------------------------------paralax---------------------------- //

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add('show-items');
            } else {
                entry.target.classList.remove('show-items')
            }
        });
    });

    const scrollScale = document.querySelectorAll('.scroll-scale');
    scrollScale.forEach((el) => observer.observe(el));

    const scrollScalle = document.querySelectorAll('.scroll-scalle');
    scrollScalle.forEach((el) => observer.observe(el));

    const scrollBottom = document.querySelectorAll('.scroll-bottom');
    scrollBottom.forEach((el) => observer.observe(el));

    const scrollTop = document.querySelectorAll('.scroll-top');
    scrollTop.forEach((el) => observer.observe(el));

    // const scrollOpen = document.querySelectorAll('.scroll-open');
    // scrollOpen.forEach((el)=>observer.observe(el));


    // ------------------------------------Read More Section---------------------------- //

    const handleReadMoreClick = () => {
        setReadMore(!readMore);
    };

    // ------------------------------------Handle submit Section---------------------------- //

    // State to store form data
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        occupation: '',
        address: '',
        phone: '',
        message: ''
    });

    const [submitMessage, setSubmitMessage] = useState('');
    const [showMessage, setShowMessage] = useState(false);
    const [isSending, setIsSending] = useState(false);

    useEffect(() => {
        let timer;
        if (showMessage) {
            timer = setTimeout(() => {
                setSubmitMessage('');
                setShowMessage(false);
            }, 10000);
        }
        return () => clearTimeout(timer);
    }, [showMessage]);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        // Check if all form fields are filled
        const isFormFilled = formData.name && formData.email && formData.occupation && formData.address && formData.phone && formData.message;

        if (!isFormFilled) {
            setSubmitMessage('Please fill out all the form fields.');
            setShowMessage(true);
            return; // Exit the function if the form is not filled
        }

        setIsSending(true); // Set isSending to true when the form submission starts

        try {
            const response = await axios.post('https://portfolio-server-sigma-blue.vercel.app/submit-form', formData); console.log(response.data);
            setSubmitMessage('Your message has been sent successfully!');
            setShowMessage(true);
            setFormData({
                name: '',
                email: '',
                occupation: '',
                address: '',
                phone: '',
                message: ''
            }); // Clear form fields
        } catch (error) {
            console.error('Error submitting form', error.response.data);
            setSubmitMessage('Failed to send message, please try again later.');
            setShowMessage(true);
        }
        setIsSending(false); // Set isSending to false when the form submission is done
    };


    // ------------------------------------services expansion Section---------------------------- //

    const toggleExpansion = (serviceId) => {
        setExpandedService(expandedService === serviceId ? null : serviceId);
    };

    // ------------------------------------Testimonial Swiper Section---------------------------- //




    return (
        <div>
        {/* ------------------------------navbar section----------------------------- */}

            <header className={isSticky ? 'sticky' : ''}>
                <div className="logo"><span>T</span>emitayo</div>
                <ul className={`navlist ${isOpen ? 'open' : ''}`}>
                    <li onClick={closeMenu}><a href="#home" className={activeSection === 'home' ? 'active' : ''} style={{ '--i': '1' }}>Home</a></li>
                    <li onClick={closeMenu}><a href="#about" className={activeSection === 'about' ? 'active' : ''} style={{ '--i': '2' }}>About</a></li>
                    <li onClick={closeMenu}><a href="#services" className={activeSection === 'services' ? 'active' : ''} style={{ '--i': '3' }}>Services</a></li>
                    <li onClick={closeMenu}><a href="#skills" className={activeSection === 'skills' ? 'active' : ''} style={{ '--i': '4' }}>Skills</a></li>
                    <li onClick={closeMenu}><a href="#portfolio" className={activeSection === 'portfolio' ? 'active' : ''} style={{ '--i': '5' }}>Portfolio</a></li>
                    <li onClick={closeMenu}><a href="#testimonies" className={activeSection === 'testimonies' ? 'active' : ''} style={{ '--i': '6' }}>Testimonia</a></li>
                    <li onClick={closeMenu}><a href="#contact" className={activeSection === 'contact' ? 'active' : ''} style={{ '--i': '7' }}>Contact</a></li>
                </ul>
                <div id="menu-icon" className={`bx ${isOpen ? 'bx-x' : 'bx-menu'}`} onClick={toggleMenu}></div>
            </header>

            {/* ------------------------------home section----------------------------- */}

            <section id="home" className="home">
                <div className="home-content scroll-scale">
                    <h1>Hi I'm Olumade Temitayo</h1>
                    <div className="change-text">
                        <h3>And I'm</h3>
                        <h3>
                            <span className="word">&nbsp;{words[currentWordIndex]}</span>
                        </h3>
                    </div>

                    <p>FullStack JavaScript | Expert in React.Js | Node.JS | Mern Stack development | (Materials and Metallurgical Engineer), working in Software
                        communities for 2years+, also specialized in UI/UX, Branding, and Digital designs
                    </p>

                    <div className="info-box">
                        <div className="email-info">
                            <h5>Motto :</h5>
                            <span>Crafting Logic, Bridging Ideas, Uniting Teams – Thriving in Code and Creativity</span>
                        </div>
                        <div className="github-info">
                            <h5>Github :</h5>
                            <span>AYOMIFROSH</span>
                        </div>
                    </div>

                    <div className="btn-box">
                        <a href="Resume.pdf" className="btn lefts" download='Temitayo resume.pdf'>Get Resume/CV</a>
                        <a href="mailto:olumadetemitayo@gmail.com?subject=Hire%20me%20from%20my%20portfolio%20website" className="btn rights">Hire Me!</a>
                    </div>

                    <div className="social-icons">
                        <a href="https://github.com/AYOMIFROSH" target="blank"><i className='bx bxl-github'></i></a>
                        <a href="https://www.linkedin.com/in/OlumadeTemitayo/" target="blank"><i className='bx bxl-linkedin-square' ></i></a>
                        <a href="https://www.instagram.com/txcoderr/" target="blank"><i className='bx bxl-instagram' ></i></a>
                        <a href="https://twitter.com/AYOMI__FROSH" target="blank"><i className='bx bxl-twitter' ></i></a>
                    </div>

                </div>

                <div className="home-image scroll-scale">
                    <div className="img-box">
                        <img src={home} alt="" />
                    </div>
                    <div className="liquid-shape">
                        <svg viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg" width="100%" id="blobSvg">
                            <path fill="#12f7ff">
                                <animate attributeName="d"
                                    dur='20000ms'
                                    repeatCount='indefinite'
                                    values="
                                M446,302.5Q432,355,384.5,378Q337,401,293.5,437.5Q250,474,196,455.5Q142,437,112.5,
                                391.5Q83,346,64.5,298Q46,250,66.5,203Q87,156,125,127.5Q163,99,206.5,80Q250,61,
                                292.5,81.5Q335,102,382,124Q429,146,444.5,198Q460,250,446,302.5Z;

                                M432.5,308Q450,366,399.5,393.5Q349,421,299.5,448Q250,475,207,437Q164,399,114,
                                378.5Q64,358,38,304Q12,250,23.5,188Q35,126,87,91.5Q139,57,194.5,73.5Q250,90,312.5,
                                62Q375,34,386.5,99Q398,164,406.5,207Q415,250,432.5,308Z;

                                M424.5,302.5Q432,355,396,397.5Q360,440,305,460.5Q250,481,204.5,444.5Q159,408,134.5,
                                369.5Q110,331,80.5,290.5Q51,250,63.5,199.5Q76,149,116,117.5Q156,86,203,75Q250,64,
                                300.5,69.5Q351,75,390.5,110.5Q430,146,423.5,198Q417,250,424.5,302.5Z;

                                M412.5,297Q413,344,387,393.5Q361,443,305.5,464.5Q250,486,196,462Q142,438,116.5,390Q91,
                                342,49,296Q7,250,45,202Q83,154,109,102.5Q135,51,192.5,30Q250,9,290.5,59.5Q331,110,358.5,
                                140.5Q386,171,399,210.5Q412,250,412.5,297Z;

                                M426.5,296.5Q410,343,380.5,384Q351,425,300.5,430.5Q250,436,190.5,445.5Q131,455,92,409.5Q53,364,
                                65.5,307Q78,250,73.5,198Q69,146,97.5,90.5Q126,35,188,20Q250,5,308.5,26.5Q367,48,398,97.5Q429,147,
                                436,198.5Q443,250,426.5,296.5Z;

                                M429,302Q430,354,394.5,396.5Q359,439,304.5,454.5Q250,470,201,445.5Q152,421,112,387Q72,353,55.5,
                                301.5Q39,250,36.5,187.5Q34,125,88,94.5Q142,64,196,76.5Q250,89,293,95.5Q336,102,378,127Q420,152,
                                424,201Q428,250,429,302Z;

                                M433,308Q451,366,389,374.5Q327,383,288.5,430Q250,477,203,445Q156,413,107.5,386.5Q59,360,67,305Q75,
                                250,80.5,202.5Q86,155,121.5,122Q157,89,203.5,61Q250,33,288.5,75Q327,117,374.5,134Q422,151,418.5,
                                200.5Q415,250,433,308Z;

                                M437.5,300Q423,350,383.5,381.5Q344,413,297,453Q250,493,201.5,456Q153,419,101,392.5Q49,366,47.5,
                                308Q46,250,44.5,190.5Q43,131,97.5,105.5Q152,80,201,67Q250,54,297.5,69.5Q345,85,384.5,117.5Q424,
                                150,438,200Q452,250,437.5,300Z;

                                M446,302.5Q432,355,384.5,378Q337,401,293.5,437.5Q250,474,196,455.5Q142,437,112.5,
                                391.5Q83,346,64.5,298Q46,250,66.5,203Q87,156,125,127.5Q163,99,206.5,80Q250,61,
                                292.5,81.5Q335,102,382,124Q429,146,444.5,198Q460,250,446,302.5Z;
                                "
                                ></animate>
                            </path>
                        </svg>
                    </div>

                    <div className="liquid-shape">
                        <svg viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg" width="100%" id="blobSvg">
                            <path fill="#12f7ff">
                                <animate attributeName="d"
                                    dur='20000ms'
                                    repeatCount='indefinite'
                                    values="
                                M446,302.5Q432,355,384.5,378Q337,401,293.5,437.5Q250,474,196,455.5Q142,437,112.5,
                                391.5Q83,346,64.5,298Q46,250,66.5,203Q87,156,125,127.5Q163,99,206.5,80Q250,61,
                                292.5,81.5Q335,102,382,124Q429,146,444.5,198Q460,250,446,302.5Z;

                                M432.5,308Q450,366,399.5,393.5Q349,421,299.5,448Q250,475,207,437Q164,399,114,
                                378.5Q64,358,38,304Q12,250,23.5,188Q35,126,87,91.5Q139,57,194.5,73.5Q250,90,312.5,
                                62Q375,34,386.5,99Q398,164,406.5,207Q415,250,432.5,308Z;

                                M424.5,302.5Q432,355,396,397.5Q360,440,305,460.5Q250,481,204.5,444.5Q159,408,134.5,
                                369.5Q110,331,80.5,290.5Q51,250,63.5,199.5Q76,149,116,117.5Q156,86,203,75Q250,64,
                                300.5,69.5Q351,75,390.5,110.5Q430,146,423.5,198Q417,250,424.5,302.5Z;

                                M412.5,297Q413,344,387,393.5Q361,443,305.5,464.5Q250,486,196,462Q142,438,116.5,390Q91,
                                342,49,296Q7,250,45,202Q83,154,109,102.5Q135,51,192.5,30Q250,9,290.5,59.5Q331,110,358.5,
                                140.5Q386,171,399,210.5Q412,250,412.5,297Z;

                                M426.5,296.5Q410,343,380.5,384Q351,425,300.5,430.5Q250,436,190.5,445.5Q131,455,92,409.5Q53,364,
                                65.5,307Q78,250,73.5,198Q69,146,97.5,90.5Q126,35,188,20Q250,5,308.5,26.5Q367,48,398,97.5Q429,147,
                                436,198.5Q443,250,426.5,296.5Z;

                                M429,302Q430,354,394.5,396.5Q359,439,304.5,454.5Q250,470,201,445.5Q152,421,112,387Q72,353,55.5,
                                301.5Q39,250,36.5,187.5Q34,125,88,94.5Q142,64,196,76.5Q250,89,293,95.5Q336,102,378,127Q420,152,
                                424,201Q428,250,429,302Z;

                                M433,308Q451,366,389,374.5Q327,383,288.5,430Q250,477,203,445Q156,413,107.5,386.5Q59,360,67,305Q75,
                                250,80.5,202.5Q86,155,121.5,122Q157,89,203.5,61Q250,33,288.5,75Q327,117,374.5,134Q422,151,418.5,
                                200.5Q415,250,433,308Z;

                                M437.5,300Q423,350,383.5,381.5Q344,413,297,453Q250,493,201.5,456Q153,419,101,392.5Q49,366,47.5,
                                308Q46,250,44.5,190.5Q43,131,97.5,105.5Q152,80,201,67Q250,54,297.5,69.5Q345,85,384.5,117.5Q424,
                                150,438,200Q452,250,437.5,300Z;

                                M446,302.5Q432,355,384.5,378Q337,401,293.5,437.5Q250,474,196,455.5Q142,437,112.5,
                                391.5Q83,346,64.5,298Q46,250,66.5,203Q87,156,125,127.5Q163,99,206.5,80Q250,61,
                                292.5,81.5Q335,102,382,124Q429,146,444.5,198Q460,250,446,302.5Z;
                                "
                                ></animate>
                            </path>
                        </svg>
                    </div>
                </div>
                {isModalVisible && activeSection === 'home' && (
                    <div className="modall scroll-scale">
                        <div className="modall-content scroll-scale">
                            <span className="close" onClick={() => setIsModalVisible(false)}>×</span>
                            <h3 style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.8rem', fontWeight: '500' }}>Exciting News!</h3>
                            <p style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.7rem' }}>The contact form is now working. Send a message 🙂 !</p>
                        </div>
                    </div>
                )}
            </section>

            {/* ------------------------------about section----------------------------- */}
            <section id="about" className="about">
                <div className="img-about scroll-scale">
                    <img src={prof} alt="" />
                    <div className="info-about1">
                        <span>2+</span>
                        <p>Years of Experience</p>
                    </div>
                    <div className="info-about2">
                        <span>36+</span>
                        <p>Project Complete</p>
                    </div>
                    <div className="info-about3">
                        <span>50+</span>
                        <p>Happy Client</p>
                    </div>
                </div>

                <div className="about-content scroll-scale">
                    <span>Let me introduce myself</span>
                    <h2>About me</h2>
                    <h3>A story of good</h3>
                    <p>I’m a passionate Fullstack JavaScript - Expert in React Development | Node.js. Also a Materials and Metallurgical Engineer
                        with a knack for logical thinking and problem-solving. At just 19 years old, i initiated my
                        programming journey with Python programming. Acquire skills in Python,
                        Numpy, Pandas, WebScraping, FileHandling, and GUI development with
                        Tkinter. I’ve honed my skills in cross-team collaboration,
                        and I’m always eager to dive into new books and resources to learn and grow. My curiosity drives me to
                        challenge my creativity and ideas, ensuring that I bring fresh, innovative solutions to the table.
                    </p>

                    {readMore && (
                        <p className="additional-about-content scroll-scalle">
                            I believe in the power of communication and teamwork to create software/Project that not only meets but exceeds expectations.
                            My personal motto, “Crafting Logic, Bridging Ideas, Uniting Teams – Thriving in Code and Creativity,”
                            reflects my commitment to excellence in both the technical and creative aspects of development.
                            <span>As I continue to build my career, I remain dedicated to pushing the boundaries of what’s possible and delivering exceptional results with every project I undertake. Let’s create something amazing together!</span>
                        </p>
                    )}

                    <div className="btn-box">
                        <button onClick={handleReadMoreClick} className="btn">
                            {readMore ? 'Read Less' : 'Read More!'}
                        </button>
                    </div>
                </div>

            </section>

            {/* ------------------------------services section----------------------------- */}

            <section id="services" className="services">
                <div className="main-text scroll-scale">
                    <span>what i will do for you</span>
                    <h2>Our Services</h2>
                </div>

                <div className="section-services scroll-bottom">
                    <div className="service-box">
                        <i className='bx bxs-devices service-icon' ></i>
                        <h3>Responsive Web Pages</h3>
                        <p>
                            Crafting sleek, dynamic web applications that adapt flawlessly across all devices,
                            delivering an optimal user experience every time.
                        </p>
                        {expandedService === 'responsive' && (
                            <div className="expanded-content">
                                {/* Add your expanded content here */}
                                <p className="scroll-scalle">Crafting Logic, Bridging Ideas, Uniting Teams – Thriving in Code and Creativity</p>
                            </div>
                        )}
                        <div className="btn-box service-btn">
                            <button onClick={() => toggleExpansion('responsive')} className="btn ">
                                {expandedService === 'responsive' ? 'Read Less' : 'Read More'}
                            </button>
                        </div>
                    </div>

                    <div className="service-box">
                        <i className='bx bx-globe service-icon' ></i>
                        <h3>Software Development</h3>
                        <p>
                            Designing and building tailored software solutions to drive business growth and innovation.
                        </p>
                        {expandedService === 'mern' && (
                            <div className="expanded-content">
                                {/* Add your expanded content here */}
                                <p className="scroll-scalle">Crafting Logic, Bridging Ideas, Uniting Teams – Thriving in Code and Creativity</p>
                            </div>
                        )}
                        <div className="btn-box service-btn">
                            <button onClick={() => toggleExpansion('mern')} className="btn">
                                {expandedService === 'mern' ? 'Read Less' : 'Read More'}
                            </button>
                        </div>
                    </div>

                    <div className="service-box">
                        <i className='bx bxl-codepen service-icon'></i>
                        <h3>UI/UX Design</h3>
                        <p>
                            Merging aesthetics with functionality to design intuitive and engaging
                            user interfaces that captivate and retain your audience.
                        </p>
                        {expandedService === 'ui/ux' && (
                            <div className="expanded-content">
                                {/* Add your expanded content here */}
                                <p className="scroll-scalle">Crafting Logic, Bridging Ideas, Uniting Teams – Thriving in Code and Creativity</p>
                            </div>
                        )}
                        <div className="btn-box service-btn">
                            <button onClick={() => toggleExpansion('ui/ux')} className="btn">
                                {expandedService === 'ui/ux' ? 'Read Less' : 'Read More'}
                            </button>
                        </div>
                    </div>

                    <div className="service-box">
                        <i className='bx bxs-layer service-icon'></i>
                        <h3>Freelancing</h3>
                        <p>
                            Offering versatile, top-tier freelance services to bring your vision
                            to life with the flexibility and dedication your project deserves.
                        </p>
                        {expandedService === 'freelancing' && (
                            <div className="expanded-content">
                                {/* Add your expanded content here */}
                                <p className="scroll-scalle">Crafting Logic, Bridging Ideas, Uniting Teams – Thriving in Code and Creativity</p>
                            </div>
                        )}
                        <div className="btn-box service-btn">
                            <button onClick={() => toggleExpansion('freelancing')} className="btn">
                                {expandedService === 'freelancing' ? 'Read Less' : 'Read More'}
                            </button>
                        </div>
                    </div>
                </div>

            </section>

            {/* ------------------------------Skills section----------------------------- */}
            <section id="skills" className="skills">
                <div className="main-text scroll-scale">
                    <span>Technical and Professional</span>
                    <h2>My Skills</h2>
                </div>

                <div className="skill-main ">
                    <div className="skill-left scroll-scale">
                        <h3>Technical Skills</h3>
                        <div className="skill-bar">
                            <div className="info">
                                <p>HTML</p>
                                <p>92%</p>
                            </div>
                            <div className="bar">
                                <span className="html"></span>
                            </div>
                        </div>

                        <div className="skill-bar">
                            <div className="info">
                                <p>JAVASCRIPT</p>
                                <p>89%</p>
                            </div>
                            <div className="bar">
                                <span className="JavaScript"></span>
                            </div>
                        </div>
                        <div className="skill-bar">
                            <div className="info">
                                <p>PYTHON</p>
                                <p>89%</p>
                            </div>
                            <div className="bar">
                                <span className="python"></span>
                            </div>
                        </div>

                        <div className="skill-bar">
                            <div className="info">
                                <p>CSS</p>
                                <p>92%</p>
                            </div>
                            <div className="bar">
                                <span className="css"></span>
                            </div>
                        </div>

                        <div className="skill-bar">
                            <div className="info">
                                <p>NODE.JS</p>
                                <p>89%</p>
                            </div>
                            <div className="bar">
                                <span className="Node"></span>
                            </div>
                        </div>

                        <div className="skill-bar">
                            <div className="info">
                                <p>API/REST-APIS</p>
                                <p>89%</p>
                            </div>
                            <div className="bar">
                                <span className="api"></span>
                            </div>
                        </div>

                        <div className="skill-bar">
                            <div className="info">
                                <p>GIT/GITHUB</p>
                                <p>95%</p>
                            </div>
                            <div className="bar">
                                <span className="git"></span>
                            </div>
                        </div>

                        <div className="skill-bar">
                            <div className="info">
                                <p>NOSQL/SQL</p>
                                <p>89%</p>
                            </div>
                            <div className="bar">
                                <span className="sql"></span>
                            </div>
                        </div>
                    </div>
                    <div className="skill-right scroll-scale">
                        <h3>Professional Skills</h3>
                        <div className="professional">
                            <div className="box">
                                <Circle dots={80} percent={80} />                                <div className="text">
                                    <big>80%</big>
                                    <small>Project Management</small>
                                </div>
                            </div>

                            <div className="box">
                                <Circle dots={80} percent={80} />                                <div className="text">
                                    <big>80%</big>
                                    <small>Creativity</small>
                                </div>
                            </div>

                            <div className="box">
                                <Circle dots={80} percent={90} />                                <div className="text">
                                    <big>90%</big>
                                    <small>Team Work</small>
                                </div>
                            </div>

                            <div className="box">
                                <Circle dots={80} percent={90} />                                <div className="text">
                                    <big>90%</big>
                                    <small>Communication</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </section>

            {/* ------------------------------Portfolio section----------------------------- */}

            <section id="portfolio" className="portfolio">
                {isModalCard && activeSection === 'portfolio' && (
                    <div className="modal scroll-scale">
                        <div className="modal-content scroll-scale">
                            <span className="close" onClick={() => setIsModalCard(false)}>×</span>
                            <h3 style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.8rem', fontWeight: '500' }}>Do You Know!</h3>
                            <p style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.7rem' }}>Hover through or Tap on the card to know more on each project and to visit each links 🌐  !</p><br />
                            <p className="PortP" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.8rem', fontFamily: 'cursive' }}>You can also filter the projects by Tapping on the Product, Interacting, and Web App</p>
                        </div>
                    </div>
                )}
                <div className="main-text scroll-scale">
                    <span>What i will do for you</span>
                    <h2>Latest Project</h2>
                </div>

                <div className="container">
                    <div className="filter-buttons scroll-scale">
                        <button className="button" data-filter='all'>All</button>
                        <button className="button" data-filter='.product'>Product</button>
                        <button className="button" data-filter='.inter'>Interacting</button>
                        <button className="button" data-filter='.web'>Web App</button>
                    </div>

                    <div className="portfolio-gallery scroll-bottom">
                        <div className="port-box mix product">
                            <div className="port-image">
                                <img src={Festal} alt="" />
                            </div>
                            <div className="port-content">
                                <h3>Festalis</h3>
                                <p>Festalis is your ultimate tool to ensure no special day goes unnoticed, 
                                    whether it's for employees, newsletter subscribers, or others you care about
                                </p>
                                <a target="blank"><i className='bx bx-link-external'></i></a>
                            </div>
                        </div>

                        <div className="port-box mix product">
                            <div className="port-image">
                                <img src={First2} alt="" />
                            </div>
                            <div className="port-content">
                                <h3>OMT Shopping</h3>
                                <p>OMT e-commerce is a dynamic and user-friendly platform that revolutionizes the way people shop online
                                </p>
                                <a href="https://omt-shopping-ease.vercel.app/" target="blank"><i className='bx bx-link-external'></i></a>
                            </div>
                        </div>

                        <div className="port-box mix inter">
                            <div className="port-image">
                                <img src={pros} alt="" />
                            </div>
                            <div className="port-content">
                                <h3>TaskZen</h3>
                                <p>This appliction allow user to create an account of there own and allow them to login.
                                    the user can create, update, and delete tasks, set task deadlines, and track their progress
                                </p>
                                <a href="#"><i className='bx bx-link-external'></i></a>
                            </div>
                        </div>

                        <div className="port-box mix inter">
                            <div className="port-image">
                                <img src={First4} alt="" />
                            </div>
                            <div className="port-content">
                                <h3>Incoming Project</h3>
                                <p>Crafting Logic, Bridging Ideas, Uniting Teams – Thriving in Code and Creativity
                                </p>
                                <a href="#"><i className='bx bx-link-external'></i></a>
                            </div>
                        </div>

                        <div className="port-box mix inter">
                            <div className="port-image">
                                <img src={First5} alt="" />
                            </div>
                            <div className="port-content">
                                <h3>Incoming Project</h3>
                                <p>Crafting Logic, Bridging Ideas, Uniting Teams – Thriving in Code and Creativity
                                </p>
                                <a href="#"><i className='bx bx-link-external'></i></a>
                            </div>
                        </div>

                        <div className="port-box mix web">
                            <div className="port-image">
                                <img src={First6} alt="" />
                            </div>
                            <div className="port-content">
                                <h3>Incoming Project</h3>
                                <p>Crafting Logic, Bridging Ideas, Uniting Teams – Thriving in Code and Creativity
                                </p>
                                <a href="#"><i className='bx bx-link-external'></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ------------------------------Testimonies section----------------------------- */}

            <section id="testimonies" className="testimonies">
                <div className="main-text scroll-scale">
                    <span>Clients & Friends Testimonials</span>
                    <h2>Testimonies</h2>
                </div>

                <div className="testi-main scroll-bottom">
                    <Swiper
                        ref={swiperRef}
                        modules={[Navigation, Pagination]}
                        slidesPerView={1}
                        grabCursor={true}
                        loop={true}
                        pagination={{
                            clickable: true,
                        }}
                        navigation={true}

                        className="testimonial mySwiper "
                    >
                        <SwiperSlide className="slide " onClick={() => swiperRef.current.swiper.slideNext()}>
                            <img src={prof} alt="" className="image" />
                            <p>also user can have their own task list, this application provides an
                                intuitive user interface and a seamless user experience
                            </p>
                            <i className='bx bxs-quote-alt-left quote-icon'></i>
                            <div className="details">
                                <span className="name">Edema Ukabi</span>
                                <span className="job">FullStack Engineer</span>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide className="slide" onClick={() => swiperRef.current.swiper.slideNext()}>
                            <img src={peter} alt="" className="image" />
                            <p>Temitayo has not only mastered multiple programming languages but has also built impressive projects, showcasing his technical expertise and creativity. &nbsp;Temitayo approaches each project with meticulous attention to detail, constantly pushing the boundaries of his skills.
                                Moreover, &nbsp;Temitayo is a collaborative team member who inspires peers with his knowledge and support. &nbsp;Temitayo is a true leader in programming, and I am confident he will continue to excel and inspire others in the field.
                            </p>
                            <i className='bx bxs-quote-alt-left quote-icon'></i>
                            <div className="details">
                                <span className="name">Chidinma Peters</span>
                                <span className="job">Python Professional</span>
                                <span className="job">Tech Instructor</span>
                            </div>
                        </SwiperSlide>
                        {/* ... add more SwiperSlide components as needed ... */}
                    </Swiper>
                </div>
            </section>


            {/* ------------------------------Contact section----------------------------- */}
            <section id="contact" className="contact">
                {isModalsVisible && activeSection === 'contact' && (
                    <div className="modals scroll-scale">
                        <div className="modals-content scroll-scale">
                            <span className="close" onClick={() => setIsModalsVisible(false)}>×</span>
                            <h3 style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.8rem', fontWeight: '500' }}>Exciting News!</h3>
                            <p style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.7rem', fontWeight: '300' }}>Kindly send me a message, or ask a question Thank you 😇 !</p>
                        </div>
                    </div>
                )}
                <div className="main-text scroll-scale">
                    <span>Ask me question</span>
                    <h2>Contact Me</h2>
                </div>
                {showMessage && <p className="submit-message" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#fff' }}>{submitMessage}</p>}

                <form className="scroll-bottom" onSubmit={handleSubmit}>
                    <input type="text" placeholder="Your Name" name="name" required value={formData.name} onChange={handleChange} />
                    <input type="text" placeholder="Your Email" name="email" required value={formData.email} onChange={handleChange} />
                    <input type="text" placeholder="Your Occupation" name="occupation" required value={formData.occupation} onChange={handleChange} />
                    <input type="text" placeholder="Your Address" name="address" required value={formData.address} onChange={handleChange} />
                    <input type="number" placeholder="Phone Number" name="phone" required value={formData.phone} onChange={handleChange} />
                    <textarea name="message" id="" cols="30" rows="10" placeholder="Your Message" value={formData.message} onChange={handleChange}></textarea>
                    <div className="btn-box formBtn">
                        <button type="submit" className="btn" disabled={isSending}>
                            {isSending ? 'Sending...' : 'Send Message'}
                        </button>
                    </div>
                </form>
            </section>

            {/* ------------------------------Footer section----------------------------- */}

            <footer id="footer" className={activeSection === 'footer' ? 'active' : ''}>
                <div className="an">
                    <a href="#home" className="scroll-scale">
                        <i className='bx bx-up-arrow-alt scroll-scale'></i>
                    </a>
                    <p className="scroll-scale">Copyright © 2024 by TxCoderr || All Right Reserved.</p>
                </div>
                <div className="subscription scroll-scale">
                    <h3 style={{ fontWeight: '1.5rem' }}>Subscribe for new updates</h3>
                    <form>
                        <input className='scroll-scale btn formBtn' type="email" placeholder="Enter your email" required style={{ height: '2rem', width: '150%' }} />
                        <div className="btn-box formBtn scroll-scale">
                            <button type="submit" className="btn" style={{ height: '2rem', width: '100%' }}>Subscribe</button>
                        </div>
                    </form>
                </div>
            </footer>

        </div>
    );
};

export default Home;